<template>
    <div>
      <h3 class="h4 text-gray-600" style="font-weight: 400;">We just need a bit more information to get started on your personalized recommendations.</h3>
      <form id="mktoForm_2489"></form>
    </div>
</template>
<script>
export default {
  name: 'Form',
  data() {
    return {
      formId: 'mktoForm_2489'
    }
  },
  methods: {
    fillInput(category) {
      //find hidden form field - ie. "industry"
      const input = document.querySelector(`input[data-sc-field-name="${category}"]`);

      // connect form field to content, "industry" field to "industry" category
      if (input) {
        if (category === "challenges" || category === "integrations" || category === "priorities") {
          input.value = this.$store.state.selectedValues[category].join(', ')
        } else {
          input.value = this.$store.state.selectedValues[category];
        }
      }
    },
    redirectSubmit() {
      if (document.getElementById(this.formId)) {
        document.getElementById(this.formId).addEventListener("submit", () => {
          var inputs = document.querySelectorAll('input[type="text"][data-val-required]');
          var valid = true;
          inputs.forEach(function(item) {
            if (item.value == null || item.value == '') {
              valid = false;
            } else if (item.getAttribute('type') === 'email' && !item.value.includes('@')) {
              valid = false;
            }
          })

          if (valid) {
            this.$emit('form-submitted', this.formId)
          }
        });
      }
    },
  },
  mounted() {
    let categories = ['approach', 'challenges', 'industry', 'integrations', 'maturity', 'priorities', 'role', 'size', 'timeframe'];

    let marketoInitialised = false;
    let retryCount = 50;

    const initialise_forms = () => {
      if (!marketoInitialised && retryCount--) {
        // Make sure Marketo script is available
        // eslint-disable-next-line
        if (typeof MktoForms2 !== "undefined") {
          // eslint-disable-next-line
          MktoForms2.loadForm(
            "//landing.hyland.com",
            "310-IWJ-963",
            "mktoForm_2489"
          );

          console.log("Forms initialised");
          marketoInitialised = true;
        } else {
          console.log("Forms not ready, try again...");
          setTimeout(initialise_forms, 100);
        }
      }
    };

    initialise_forms();

    for (let i = 0; i < categories.length; i++) {
      this.fillInput(categories[i]);
    }

    this.redirectSubmit();
  }
}
</script>